export default __webpack_public_path__ + "static/media/Mordec Greaves.b5026205.jpg";